import Compressor from 'compressorjs'

export const getExtensionFromMimeType = (mimeType) => {
  const extensions = {
    'image/jpeg': '.jpg',
    'image/png': '.png',
    'image/webp': '.webp',
    'image/heic': '.heic',
    'image/heif': '.heif'
  }
  return extensions[mimeType] || '.jpg' // fallback to jpg if unknown type
}

// Modern phone cameras capture ~12MP (e.g. 4032x3024). That resolution is far
// more than the API needs and produces multi-MB uploads that stall on field
// cellular connections. Cap the longest edge so dimensions shrink (the biggest
// payload lever), then scale JPEG quality logarithmically once images exceed
// 500KB so very large photos shrink aggressively while small photos stay
// near-lossless.
const MAX_IMAGE_DIMENSION = 2000

export const compressImage = (image) => {
  if (image.type && !image.type.startsWith('image/')) {
    return Promise.resolve(image)
  }

  const fileSizeKb = image.size / 1000
  const quality = fileSizeKb > 500
    ? Math.max(0.4, 1.0 - (0.16 * Math.log2(fileSizeKb / 500)))
    : 0.9

  return new Promise((resolve, reject) => {
    new Compressor(image, {
      quality: quality,
      maxWidth: MAX_IMAGE_DIMENSION,
      maxHeight: MAX_IMAGE_DIMENSION,
      convertSize: 0, // ensures all images can be converted
      mimeType: 'image/jpeg', // convert PNG → JPEG
      success: (compressedFile) => resolve(compressedFile),
      error: (error) => reject(error)
    })
  })
}
